import { render } from "./ConsultationPatientVitalsTab.vue?vue&type=template&id=8d9bf54a&scoped=true"
import script from "./ConsultationPatientVitalsTab.vue?vue&type=script&lang=js"
export * from "./ConsultationPatientVitalsTab.vue?vue&type=script&lang=js"

import "./ConsultationPatientVitalsTab.vue?vue&type=style&index=0&id=8d9bf54a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8d9bf54a"]])

export default __exports__